/***********************************************  Size variation convert into accordion ***********************************************/

// $(document).ready(function() {
//     // Wrap swatches content inside an accordion content div
//     var swatchesContainer = $('.swatches__container');

//     swatchesContainer.each(function() {
//         var swatchHeader = $(this).find('.swatches__option-name');
//         var swatchesContent = $(this).children(':not(.swatches__option-name)');
        
//         // Create a wrapper for swatches content (this will be hidden by default)
//         swatchesContent.wrapAll('<div class="accordion-content" style="display: none;"></div>');

//         // Add the toggle arrow to the header
//         swatchHeader.append('<span class="dropdown-arrow accordion-arrow"><svg class="transform transition-transform duration-300 w-lg h-lg rotate-0 icon--apollo-down-carrot c-accordion__header--icon vib-center" height="6px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 13.3" xml:space="preserve"><g class="hover-fill" fill="var(--text-color)"><polygon points="17.7,0 10,8.3 2.3,0 0,2.5 10,13.3 20,2.5 "></polygon></g><style>.c-accordion__header .icon--apollo-down-carrot:hover .hover-fill { fill: var(--text-color);}</style></svg></span>');
//         // Add click event to toggle the accordion
//         swatchHeader.on('click', function() {
//             var content = $(this).next('.accordion-content');
//             content.slideToggle(); // Toggle the accordion content
//             $(this).toggleClass('open');
//             $(this).find('.accordion-arrow').toggleClass('rotate');
//         });
//     });

//     // Add CSS via jQuery (if needed)
//     $('<style>')
//     .prop('type', 'text/css')
//     .html(`
//         .accordion-arrow {
//             transition: transform 0.3s;
//             float: right;
//         }
//         .rotate {
//             transform: rotate(180deg);
//         }
//     `)
//     .appendTo('head');
// });


/*********************************************** END ***********************************************/


/*********************************************** pageload on select color swatch ***********************************************/

// document.addEventListener('DOMContentLoaded', function() {
//   // Select all elements with the class 'swatches__form--label'
//   const swatchLabels = document.querySelectorAll('.swatches__form--label');

//   // Add a click event listener to each swatch label
//   swatchLabels.forEach(function(label) {
//     label.addEventListener('click', function() {
//       // Set a timeout before reloading the page (e.g., 2000 milliseconds = 2 seconds)
//       setTimeout(function() {
//         location.reload();  // Reload the page after the specified time
//       }, 500);  // Delay time in milliseconds (2000 ms = 2 seconds)
//     });
//   });
// });




/*********************************************** END ***********************************************/

/*********************************************** ACCORDIANS (collapse product page) ***********************************************/

$(document).ready(function(){
  $('.products_addons_list').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev"><span class="dropdown-arrow accordion-arrow"><svg xmlns:xlink="http://www.w3.org/1999/xlink" class="transform transition-transform duration-300 w-lg h-lg rotate-0" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" viewBox="0 0 24 24" fill="none" width="16" height="16"><title fill="none">Caret</title><path d="M8.59175 20C8.47866 19.9947 8.36933 19.9555 8.27647 19.8871C8.18361 19.8187 8.11104 19.7238 8.06721 19.6135C8.02338 19.5031 8.01008 19.3819 8.02886 19.2639C8.04765 19.146 8.09774 19.036 8.17332 18.9469L14.7188 12.0179L8.17332 5.06776C8.06235 4.95046 8 4.79137 8 4.62548C8 4.45959 8.06235 4.3005 8.17332 4.1832C8.28429 4.0659 8.43481 4 8.59175 4C8.74869 4 8.89921 4.0659 9.01018 4.1832L15.7051 11.2492C15.7985 11.3471 15.8726 11.4635 15.9231 11.5918C15.9737 11.7202 15.9998 11.8578 15.9998 11.9968C15.9998 12.1358 15.9737 12.2735 15.9231 12.4018C15.8726 12.5301 15.7985 12.6466 15.7051 12.7445L9.01018 19.8105C8.95621 19.8703 8.8913 19.918 8.81937 19.9506C8.74744 19.9832 8.67 20 8.59175 20Z" fill="#0A0A0A"></path></svg></span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="dropdown-arrow accordion-arrow"><svg xmlns:xlink="http://www.w3.org/1999/xlink" class="transform transition-transform duration-300 w-lg h-lg rotate-0" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" viewBox="0 0 24 24" fill="none" width="16" height="16"><title fill="none">Caret</title><path d="M8.59175 20C8.47866 19.9947 8.36933 19.9555 8.27647 19.8871C8.18361 19.8187 8.11104 19.7238 8.06721 19.6135C8.02338 19.5031 8.01008 19.3819 8.02886 19.2639C8.04765 19.146 8.09774 19.036 8.17332 18.9469L14.7188 12.0179L8.17332 5.06776C8.06235 4.95046 8 4.79137 8 4.62548C8 4.45959 8.06235 4.3005 8.17332 4.1832C8.28429 4.0659 8.43481 4 8.59175 4C8.74869 4 8.89921 4.0659 9.01018 4.1832L15.7051 11.2492C15.7985 11.3471 15.8726 11.4635 15.9231 11.5918C15.9737 11.7202 15.9998 11.8578 15.9998 11.9968C15.9998 12.1358 15.9737 12.2735 15.9231 12.4018C15.8726 12.5301 15.7985 12.6466 15.7051 12.7445L9.01018 19.8105C8.95621 19.8703 8.8913 19.918 8.81937 19.9506C8.74744 19.9832 8.67 20 8.59175 20Z" fill="#0A0A0A"></path></svg></span></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
});

$( ".pair-with-products" ).hover(
  	() => { //hover
    	$(".pair-with-products .slick-arrow").addClass("show");
  	}, 
  	() => { //out
    	$(".pair-with-products .slick-arrow").removeClass("show");
  	}
);

/*********************************************** END ***********************************************/


$(document).ready(function () {
    // Include Slick Slider CSS and JS dynamically if not already added
    if (!$("link[href*='slick.css']").length) {
        $("head").append(
            '<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css">'
        );
        $("head").append(
            '<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css">'
        );
    }

    if (!$("script[src*='slick.min.js']").length) {
        $.getScript(
            "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js",
            function () {
                initializeSlider();
            }
        );
    } else {
        initializeSlider();
    }

    function initializeSlider() {
        $(".home-collection-list .collection__list-container").slick({
            infinite: true,
            slidesToShow: 3, // Main slides to show
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            // centerMode: true, // Enables center mode
            // centerPadding: "2%", // Shows a 2% preview of the next slide
            prevArrow:
                '<div class="custom-arrow arrow-left"><svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" class="flickity-button-icon" viewBox="0 0 100 100" width="100" height="100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" class="arrow" fill="#2B2A4C"></path></svg></div>',
            nextArrow:
                '<div class="custom-arrow arrow-right"><svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" class="flickity-button-icon" viewBox="0 0 100 100" width="100" height="100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) " fill="#2B2A4C"></path></svg></div>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        // centerMode: true,
                        // centerPadding: "5%", // Adjust for smaller screens
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        // centerMode: true,
                        // centerPadding: "10%", // Adjust for smallest screens
                    },
                },
            ],
        });
    }
});


/*********************************************** END ***********************************************/

/*********************************************** ADD ANIMATE CLASS IN SLIDER ARROWS  ***********************************************/

$(document).ready(function () {
    $(".home-collection-list .collection__list-container").hover(
        function () {
            // Trigger animation on hover
            $(".custom-arrow.arrow-left").css("animation", "fadeInLeft 0.3s forwards");
            $(".custom-arrow.arrow-right").css("animation", "fadeInRight 0.3s forwards");
        },
        function () {
            // Reset animation on hover out
            $(".custom-arrow.arrow-left").css("animation", "fadeOutLeft 0.3s forwards");
            $(".custom-arrow.arrow-right").css("animation", "fadeOutRight 0.3s forwards");
          
        }
    );
});


$(document).ready(function () {
    $(".blinix-product-wrapper").hover(
        function () {
            // Trigger animation on hover
            $(".blinix-product-wrapper .slick-prev.slick-arrow").css("animation", "fadeInLeft 0.3s forwards");
            $(".blinix-product-wrapper .slick-next.slick-arrow").css("animation", "fadeInRight 0.3s forwards");
        },
        function () {
            // Reset animation on hover out
            $(".blinix-product-wrapper .slick-prev.slick-arrow").css("animation", "fadeOutLeft 0.3s forwards");
            $(".blinix-product-wrapper .slick-next.slick-arrow").css("animation", "fadeOutRight 0.3s forwards");
          
        }
    );
});


$(document).ready(function () {
    $(".featured__collection-carousel").hover(
        function () {
            // Trigger animation on hover
            $(".flickity-button.previous").css("animation", "fadeInLeft 0.3s forwards");
            $(".flickity-button.next").css("animation", "fadeInRight 0.3s forwards");
        },
        function () {
            // Reset animation on hover out
            $(".flickity-button.previous").css("animation", "fadeOutLeft 0.3s forwards");
            $(".flickity-button.next").css("animation", "fadeOutRight 0.3s forwards");
          
        }
    );
});


/***************** end *******************/

document.addEventListener("DOMContentLoaded", function () {
    // Hide all tab contents except the first one on page load
    $(".tab-content").hide();
    $(".tab-content:first").addClass("blinix-active").show();

    // Add active class to the first tab on page load
    $("#tabs-nav li:first-child").addClass("active");

    // Function to initialize Slick Slider for a specific tab
    function initializeSlickSlider(tab) {
        $(tab).find('.blinix-product-wrapper').slick({
            arrows: true,
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    // Initialize slick for the first active tab
    initializeSlickSlider(".tab-content:first");

    // Function to handle tab switching
    $("#tabs-nav li").on("click", function (e) {
        e.preventDefault(); // Prevent default anchor behavior

        // Get the clicked tab and the corresponding tab content
        var activeTab = $(this).find("a").attr("href");

        // Only proceed if the clicked tab is not already active
        if (!$(this).hasClass("active")) {
            // Remove active state from all tabs
            $("#tabs-nav li").removeClass("active");
            $(this).addClass("active");

            // Hide the currently active tab content immediately
            $(".tab-content.blinix-active").hide().removeClass("blinix-active");

            // Show the new tab content immediately without delay
            $(activeTab).show().addClass("blinix-active");

            // Destroy any existing Slick instances on the new active tab to avoid conflicts
            if ($(activeTab).find('.blinix-product-wrapper').hasClass('slick-initialized')) {
                $(activeTab).find('.blinix-product-wrapper').slick('unslick');
            }

            // Reinitialize Slick for the new active tab immediately
            initializeSlickSlider(activeTab);
        }
    });
});







// Swatches
document.addEventListener('change', function (event) {
  const gemstoneInput = event.target.closest(
    '.template-product-gemstone .gemstone-swatches-container .swatches__form--input'
  );

  if (!gemstoneInput) return;

  const container = gemstoneInput.closest(
    '.gemstone-swatches-container'
  );

  if (!container) return;

  const selectedLabel = container.querySelector(
    '.swatches__option-value'
  );

  if (!selectedLabel) return;

  selectedLabel.textContent = gemstoneInput.value;
});


// collection cards




(() => {
  const updateVariantImage = (cardId, button) => {
    const imageCard = document.querySelector(
      `.js-collection-variant-image[data-variant-card-id="${cardId}"]`
    );

    if (!imageCard) return;

    const variantImage = button.dataset.variantImage;
    const variantImageAlt = button.dataset.variantImageAlt;

    if (variantImage) {
      const revealContainer = imageCard.querySelector('.prod-image .reveal');
      const mainImage = revealContainer
        ? revealContainer.querySelector('img')
        : null;

      if (mainImage) {
        mainImage.src = variantImage;
        mainImage.srcset = variantImage;

        mainImage.setAttribute('data-src', variantImage);
        mainImage.setAttribute('data-srcset', variantImage);

        if (variantImageAlt) {
          mainImage.alt = variantImageAlt;
        }

        const picture = mainImage.closest('picture');

        if (picture) {
          picture.querySelectorAll('source').forEach((source) => {
            source.srcset = variantImage;
            source.setAttribute('data-srcset', variantImage);
          });
        }
      }
    }
  };

  const updateVariantPrice = (detailsCard, button) => {
    const currentPrice = detailsCard.querySelector(
      '.js-card-current-price'
    );

    const comparePrice = detailsCard.querySelector(
      '.js-card-compare-price'
    );

    if (currentPrice && button.dataset.variantPrice) {
      currentPrice.textContent = button.dataset.variantPrice;
    }

    if (!comparePrice) return;

    const isOnSale = button.dataset.variantOnSale === 'true';
    const variantComparePrice = button.dataset.variantComparePrice;

    if (isOnSale && variantComparePrice) {
      comparePrice.textContent = variantComparePrice;
      comparePrice.hidden = false;
    } else {
      comparePrice.textContent = '';
      comparePrice.hidden = true;
    }
  };

  const updateVariantLinks = (cardId, button) => {
    const variantUrl = button.dataset.variantUrl;

    if (!variantUrl) return;

    document
      .querySelectorAll(
        `[data-variant-card-id="${cardId}"] .js-card-product-link`
      )
      .forEach((link) => {
        link.href = variantUrl;
      });

    const imageCard = document.querySelector(
      `.js-collection-variant-image[data-variant-card-id="${cardId}"]`
    );

    if (!imageCard) return;

    const quickViewButton = imageCard.querySelector(
      '.js-quickview-trigger'
    );

    if (quickViewButton) {
      quickViewButton.dataset.productUrl = `${variantUrl}&view=quick`;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.card-gemstone-swatch');

    if (!button || button.disabled) return;

    const detailsCard = button.closest(
      '.js-collection-variant-details'
    );

    if (!detailsCard) return;

    event.preventDefault();
    event.stopPropagation();

    const cardId = detailsCard.dataset.variantCardId;

    if (!cardId) return;

    detailsCard
      .querySelectorAll('.card-gemstone-swatch')
      .forEach((swatch) => {
        swatch.classList.remove('is-active');
        swatch.setAttribute('aria-pressed', 'false');
      });

    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');

    updateVariantPrice(detailsCard, button);
    updateVariantImage(cardId, button);
    updateVariantLinks(cardId, button);
  });
})();









document.addEventListener('DOMContentLoaded', function () {
  moveXBWishlist();
});

document.addEventListener('shopify:section:load', function () {
  moveXBWishlist();
});

function moveXBWishlist() {

  document.querySelectorAll('.product__section-details').forEach(function(section) {

    const productAdd = section.querySelector('.product-add');
    const wishlist = section.querySelector('xb-wishlist-button');

    if (!productAdd || !wishlist) return;

    const appWrapper = wishlist.closest(
      '.product__section-details__inner'
    );

    if (!appWrapper) return;

    if (productAdd.contains(appWrapper)) return;

    productAdd.appendChild(appWrapper);

  });

}


// burgericon js

// document.addEventListener("DOMContentLoaded", function(){

// const wrapper = document.querySelector(".mobile-menu__trigger");
// const openBtn = document.querySelector(".menu-open-btn");
// const closeBtn = document.querySelector(".menu-close-btn");


// if(!wrapper || !openBtn || !closeBtn) return;


// openBtn.addEventListener("click", function(){

//     wrapper.classList.add("menu-active");

// });


// closeBtn.addEventListener("click", function(){

//     wrapper.classList.remove("menu-active");

// });


// });

document.addEventListener("DOMContentLoaded", function(){

const wrapper = document.querySelector(".mobile-menu__trigger");
const openBtn = document.querySelector(".menu-open-btn");
const closeBtn = document.querySelector(".menu-close-btn");


if(!wrapper || !openBtn || !closeBtn) return;


openBtn.addEventListener("click",()=>{

wrapper.classList.add("menu-active");

});


closeBtn.addEventListener("click",()=>{

wrapper.classList.remove("menu-active");

});


});

// document.addEventListener("DOMContentLoaded", function () {

//   const header = document.querySelector(".header-section");
//   const menuOpen = document.querySelector(".menu-open-btn");
//   const menuClose = document.querySelector(".menu-close-btn");

//   if(!header) return;


//   menuOpen?.addEventListener("click", function(){

//     setTimeout(()=>{

//       document.body.classList.add("mobile-menu-open");
//       header.classList.add("mobile-menu-sticky");

//     },50);


//   });



//   menuClose?.addEventListener("click", function(){

//     document.body.classList.remove("mobile-menu-open");
//     header.classList.remove("mobile-menu-sticky");

//   });


// });


// header working js

// document.addEventListener("DOMContentLoaded", function(){

//     const header = document.querySelector(".header-section");
//     const menuTrigger = document.querySelector(".mobile-menu__trigger");

//     if(!header || !menuTrigger) return;


//     const observer = new MutationObserver(function(){

//         if(menuTrigger.classList.contains("menu-active")){

//             header.classList.add("force-mobile-sticky");

//         }else{

//             header.classList.remove("force-mobile-sticky");

//         }

//     });


//     observer.observe(menuTrigger,{
//         attributes:true,
//         attributeFilter:["class"]
//     });


// });




// ===================================================
// ==============================off cnavas sticky issue=====================
// ===================================================

// document.addEventListener("DOMContentLoaded", function(){

//     const header = document.querySelector(".header-section");
//     const menuTrigger = document.querySelector(".mobile-menu__trigger");

//     if(!header || !menuTrigger) return;


//     function updateHeaderPosition(){

//         if(menuTrigger.classList.contains("menu-active")){

//             if(window.scrollY <= 10){

//                 header.style.top = "24px";

//             }else{

//                 header.style.top = "0px";

//             }

//         }

//     }


//     window.addEventListener("scroll", updateHeaderPosition);


//     const observer = new MutationObserver(function(){

//         if(menuTrigger.classList.contains("menu-active")){

//             header.classList.add("force-mobile-sticky");

//             updateHeaderPosition();

//         }else{

//             header.classList.remove("force-mobile-sticky");
//             header.style.top = "";

//         }

//     });


//     observer.observe(menuTrigger,{
//         attributes:true,
//         attributeFilter:["class"]
//     });


// });